/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Myaccess_Description1Inputs */

const en_settings_myaccess_description1 = /** @type {(inputs: Settings_Myaccess_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See your user role access across all the funds in the selected organization`)
};

/**
* | output |
* | --- |
* | "See your user role access across all the funds in the selected organization" |
*
* @param {Settings_Myaccess_Description1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_myaccess_description1 = /** @type {((inputs?: Settings_Myaccess_Description1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Myaccess_Description1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_myaccess_description1(inputs)
});
export { settings_myaccess_description1 as "settings_myAccess_description" }